import styled from "@emotion/styled";
import { Col, Row, Table } from "antd";
import { CustomButon } from "./CommonHeader";
import touzi4 from "../../../../images/touzi-4.png";
import jiansheImg from "../../../../images/jianshe-4.png";
import jianshebox from "../../../../images/jianshe-box.png";
import jiansheActive from "../../../../images/jianshe-item.png";
import th from "../../../../images/th1.png";
import tr from "../../../../images/tr.png";
import { ColumnsType } from "antd/es/table/interface";
import YearPicker from "../../../../components/YearPicker";
import xiangmuImg from "../../../../images/xiangmu-6.png";
import { DualAxes } from "@ant-design/plots";
import line3 from "../../../../images/line3.png";
import { useCallback, useEffect, useState } from "react";
import request from "../../../../utils/request";

const Layout = styled.div`
  .flex {
    display: flex;
  }
  .ac {
    align-items: center;
  }
  .column {
    flex-direction: column;
  }
  .box-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
    width: 1545px;
    margin-top: 15px;
  }

  .base-info-btn {
    color: #fff;
    font-weight: bold;
    font-size: 20px;

    align-items: center;
    img {
      margin-right: 5px;
    }
    span {
      margin-left: 8px;
    }
  }
  .table-wrapper {
    margin-top: 33px;
  }

  .ant-table {
    background-color: transparent;
    thead {
      background-image: url(${th});
    }
    th {
      background-color: transparent !important;
      color: #fff !important;
      font-size: 14px !important;
      border: none !important;
      height: 40px !important;
      padding: 0 !important;
      &::before {
        display: none !important;
      }
    }
    td {
      color: #1cfbff !important;
      border: none !important;
      background-color: transparent !important;
    }
    tr:hover {
      td {
        background-color: transparent !important;
        border: none !important;
      }
    }
    tbody tr {
      background-image: url(${tr});
      border: none !important;
      &:nth-child(odd) {
        // background-image: url();
      }
    }
  }
`;

export const HuanBao: React.FC<{
  id?: number;
}> = ({ id }) => {
  //环保检查
  const [inspect, setInspect] = useState<Record<string, any>[]>([]);
  //环保核查
  const [secure, setSecure] = useState<Record<string, any>[]>([]);
  const getData = useCallback(() => {
    if (!id) return;
    // https://apiv2.wxstores.cn/screen/company/getCompanyInspect?comid=2818
    // https://apiv2.wxstores.cn/screen/company/getCompanySecure?comid=2818
    request.get("/screen/company/getCompanyInspect?comid=" + id).then((res) => {
      console.log("res", res);
      if (res.data?.data) {
        setInspect(res.data?.data.inspect || []);
        setSecure(res.data?.data.secure || []);
      }
    });
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const columns: ColumnsType<any> = [
    {
      title: "序号",
      dataIndex: "",
      align: "center",
      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "企业名称",
      align: "center",
      dataIndex: "company_title",
    },
    {
      title: "文件类型",
      align: "center",
      dataIndex: "cat_name",
    },
    {
      title: "提交时间",
      align: "center",
      dataIndex: "createtime",
    },
    {
      title: "状态",
      align: "center",
      dataIndex: "status",
      render(value, record) {
        const map = {
          0: "待审核",
          1: "审核通过",
          2: "未通过",
        } as any;
        return map[value];
      },
    },
    {
      title: "审核人",
      align: "center",
      dataIndex: "statecreator",
    },
    {
      title: "审核时间",
      align: "center",
      dataIndex: "statetime",
    },
    {
      title: "备注",
      align: "center",
      dataIndex: "desc",
    },
    // {
    //   title: "操作",
    //   align: "center",
    //   dataIndex: "month",
    // },
  ];
  const columns1: ColumnsType<any> = [
    {
      title: "序号",
      dataIndex: "",
      align: "center",
      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "检查企业",
      align: "center",
      dataIndex: "company_title",
    },
    {
      title: "日期",
      align: "center",
      dataIndex: "createtime",
    },
    {
      title: "检查类型",
      align: "center",
      dataIndex: "type_name",
    },
    {
      title: "外出检查人员",
      align: "center",
      dataIndex: "people",
    },
    {
      title: "同行领导（部门）",
      align: "center",
      dataIndex: "leader",
    },
    {
      title: "检查结果",
      align: "center",
      dataIndex: "status_name",
      // render(value, record) {
      //   const checkResultOptions = [
      //     {
      //       label: "正常",
      //       value: "1",
      //     },
      //     {
      //       label: "现场问题整改",
      //       value: "2",
      //     },
      //     {
      //       label: "下达文件整改",
      //       value: "3",
      //     },
      //   ];
      //   return checkResultOptions.find((item: any) => item.value == value)
      //     ?.label;
      // },
    },
    // {
    //   title: "操作",
    //   align: "center",
    //   dataIndex: "month",
    // },
  ];
  return (
    <Layout>
      <div className="box-item table-box">
        <div className="base-info-btn flex">
          <img src={line3} width="7" height="21" alt="" />
          <span>环保监管</span>
        </div>
        <div className="table-wrapper">
          <Table
            columns={columns}
            pagination={false}
            dataSource={secure}
            locale={{
              emptyText: "暂无数据",
            }}
          />
        </div>
      </div>
      <div className="box-item table-box">
        <div className="base-info-btn flex">
          <img src={line3} width="7" height="21" alt="" />
          <span>环保检查</span>
        </div>
        <div className="table-wrapper">
          <Table
            columns={columns1}
            pagination={false}
            dataSource={inspect}
            locale={{
              emptyText: "暂无数据",
            }}
          />
        </div>
      </div>
    </Layout>
  );
};
